var GiftAddresses = (function (CheckoutApiCollection, Address) {
    return CheckoutApiCollection.extend({
        model: Address,

        initialize: function () {
            //this.fetch();
        },

        fetch: function () {
            var $deff = new $.Deferred();

            this._api.getUserGiftAddresses()
                .done(_.bind(function (data) {
                    var list = data && data.Value && data.Value.AddressesList || [];
                    if (list.length > 1) {
                        this._success(data);
                        $deff.resolve();
                    } else {
                        $deff.reject();
                    }
                }, this));

            return $deff.promise();
        },

        isActive: function () {
            return this._isActive;
        },

        setActive: function (isActive) {
            this._isActive = isActive;
            this.trigger('isActive', isActive);
        },

        isValid: function () {
            this.trigger('isValid', false);
            return false;
        },

        _success: function (data) {
            var addresses = []; //tbd: use where
            if (data !== null) {
                _.each(data.Value.AddressesList,
                    function(address) {
                        if (address.ID && address.ID !== '00000000-0000-0000-0000-000000000000') {
                            addresses.push(address);
                        }
                    });
            }
            this.update(addresses);
        }
    });
})(CheckoutApiCollection, Address);
